import { gtmEvents } from 'constants/gtmEvent';
import pagesUrls from 'constants/pagesUrls';

import type { FooterItemsTypes } from 'components/layouts/Footer/types';

export const colorsVariables = {
  purple: {
    '--background': 'var(--purple-gradient-5)',
  },
  peach: {
    '--background': 'var(--peach-gradient-5)',
  },
  marine: {
    '--background': 'var(--marine-gradient-5)',
  },
  blue: {
    '--background': 'var(--dark-blue-background)',
  },
  lilac: {
    '--background': 'var(--lilac-gradient-5)',
  },
};

export const productsItems: FooterItemsTypes[] = [
  {
    name: 'а3.банки',
    href: pagesUrls.banks,
    gtmEvent: gtmEvents.clickFooterBanks,
  },
  {
    name: 'а3.платёжные сервисы',
    href: pagesUrls.paymentServices,
    gtmEvent: gtmEvents.clickFooterPaymentServices,
  },
  {
    name: 'а3.поставщики услуг',
    href: pagesUrls.providers,
    gtmEvent: gtmEvents.clickFooterProviders,
  },
  {
    name: 'а3.лк поставщика',
    href: pagesUrls.providerAccount,
    gtmEvent: gtmEvents.clickFooterProviderAccount,
  },
];

export const contactsItems: FooterItemsTypes[] = [
  {
    name: 'Работа у нас',
    href: pagesUrls.work,
    gtmEvent: gtmEvents.clickFooterWork,
  },
  {
    name: 'Документы',
    href: pagesUrls.documents,
    gtmEvent: gtmEvents.clickFooterDocuments,
  },
  {
    name: 'Контакты',
    href: pagesUrls.contacts,
    gtmEvent: gtmEvents.clickFooterContacts,
  },
];
